
export function showPopup(message, title = '', callback) {
  const PLATFORM = window?.WebApp?.initDataUnsafe?.user?.id
    ? 'MAX'
    : window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
      ? 'TELEGRAM'
      : null;
  const DEV_MODE = process.env.NODE_ENV === 'development';
  if (DEV_MODE) {
    alert(title + '\n' + message);
    console.log(message);
  } else {
    if (PLATFORM === 'MAX') {
      alert(title + '\n' + message);
      console.log(message);
      callback()
    } else if (PLATFORM === 'TELEGRAM') {
      window.Telegram.WebApp.showPopup(
        {
          message: message,
          title: title,
          type: 'alert',
        },
        callback(),
      );
    }
  }
}
